import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Paper, Box, FormHelperText } from "@mui/material";
import PaletteIcon from '@mui/icons-material/Palette';
import CodeEditor from '@uiw/react-textarea-code-editor';
import { FullWidthButton } from "../FullWidthButton";
import { adminAxios } from "../../services/http/adminAxios";
import { mainStore } from "../../store/MainStore";

const CustomThemeEditor = ({ obj }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [template, setTemplate] = useState(null)
    const [validationError, setValidationError] = useState(null)

    useEffect(() => {
        adminAxios.get('projects/theme-template').then((res) => setTemplate(res.data))
    }, [])

    const templateText = template ? JSON.stringify(template, null, 2) : ''

    const handleChange = (e) => {
        mainStore.isSaved = false
        obj.value = e.target.value
        obj.error = false
        setValidationError(null)
    }

    const handleClear = () => {
        mainStore.isSaved = false
        obj.value = ''
        setValidationError(null)
    }

    const handleFillWithExample = () => {
        mainStore.isSaved = false
        obj.value = templateText
        setValidationError(null)
    }

    const handleOpen = () => {
        try {
            obj.value = JSON.stringify(JSON.parse(obj.value), null, 2)
        } catch {
            // leave invalid/empty JSON as-is so the user can see and fix it
        }
        setIsOpen(true)
    }

    const handleDone = async () => {
        const res = await adminAxios.post('projects/theme/validate', { theme: obj?.value || '' })
        if (!res.data.isValid) {
            setValidationError(res.data.error)
            return
        }
        setValidationError(null)
        setIsOpen(false)
    }

    return (
        <Paper style={{ padding: 16, marginTop: 16 }}>
            <FullWidthButton
                startIcon={<PaletteIcon style={{ height: 20 }} />}
                onClick={handleOpen}
            >
                {obj?.value ? 'Edit custom theme' : 'Add custom theme'}
            </FullWidthButton>
            {obj?.error && <FormHelperText error>{obj.error}</FormHelperText>}

            <Dialog open={isOpen} onClose={handleDone} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ borderBottom: '2px solid', borderColor: 'primary.main' }}>
                    Custom Theme (JSON)
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }}>
                        <CodeEditor
                            value={obj?.value || ''}
                            language="json"
                            placeholder={templateText}
                            onChange={handleChange}
                            data-color-mode={mainStore.theme}
                            minHeight={220}
                            padding={12}
                            style={{
                                fontFamily: 'ui-monospace, Menlo, Consolas, monospace',
                                fontSize: 13,
                            }}
                        />
                    </Box>
                    {validationError && <FormHelperText error>{validationError}</FormHelperText>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClear} color="warning">Clear</Button>
                    <Button onClick={handleFillWithExample} disabled={!template}>Fill with example</Button>
                    <Button variant="contained" onClick={handleDone}>Done</Button>
                </DialogActions>
            </Dialog>
        </Paper>
    );
}

const o = observer(CustomThemeEditor)
export { o as CustomThemeEditor };
